const desktop = ['Chrome', 'Firefox', 'Opera', 'OPR', 'MSIE']
const mobile = ['iPhone', 'iPad', 'iPod', 'Windows Phone', 'Android', 'webOS']
const browserIncluded = agents =>
  agents.some(agent => navigator.userAgent.includes(agent))

export const isGradCompatible = browserIncluded(desktop)
export const isMobile = browserIncluded(mobile)

export default {
  isGradCompatible,
  isMobile,
}
